module.exports = __webpack_public_path__ + "img/组 1.b652da72.webp";